import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App.tsx';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig.ts';


const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);

const root = createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <App msalInstance={msalInstance}/>
  </StrictMode>,
);
